export default __webpack_public_path__ + "static/media/Leanpos.347ef6ef.png";